import { NAME as APP_NAME } from 'constants';
import * as I18n from 'circe/I18n';

export const NAME = `${APP_NAME}/SYSTEM_USERS`;

export const REDUCER_NAME = 'users';

export const LISTING_ENDPOINT = `${OPERATIONS_EDGE}/api/profiles/query`;

export const ROUTES = {
  ROOT: '/users',
};
export const STATUS = {
  ACTIVE: I18n.str('ACTIVE', 'ACTIVE'),
  PENDING_ACTIVATION: I18n.str('PENDING_ACTIVATION', 'PENDING_ACTIVATION'),
  SUSPENDED: I18n.str('SUSPENDED', 'SUSPENDED'),
};

export const ROLES = {
  ACCOUNT_ADMIN: I18n.str('ACCOUNT_ADMIN', 'Account Admin'),
  DRIVER: I18n.str('DRIVER', 'Driver'),
  FINANCE_ADMIN: I18n.str('FINANCE_ADMIN', 'Finance Admin'),
  FLEET_ADMIN: I18n.str('FLEET_ADMIN', 'Fleet Admin'),
  OPERATOR: I18n.str('OPERATOR', 'Operator'),
  SHIPPER: I18n.str('SHIPPER', 'Shipper'),
  FACILITY_ADMIN: I18n.str('FACILITY_ADMIN', 'Facility Admin'),
  FACILITY_OPS_MANAGER: I18n.str('FACILITY_OPS_MANAGER', 'Facility OPS Manager'),
  ASSOCIATE: I18n.str('ASSOCIATE', 'Associate'),
  DISPATCHER: I18n.str('DISPATCHER', 'Dispatcher'),
  SECURITY_GUARD: I18n.str('SECURITY_GUARD', 'Security Guard'),
  CASHIER: I18n.str('CASHIER', 'Cashier'),
  CALL_CENTER_ASSOCIATE: I18n.str('CALL_CENTER_ASSOCIATE', 'Call Center Associate'),
};

export const INITAIS_ROLES = [
  'ACCOUNT_ADMIN',
  'OPERATOR',
  'DISPATCHER',
  'CALL_CENTER_ASSOCIATE',
  'CASHIER',
  'FINANCE_ADMIN',
  'FLEET_ADMIN',
  'SECURITY_GUARD',
];
